let sw = window.innerWidth;
let sh = window.innerHeight;

function fontResizer() {
  let perc = parseInt(sw) / 120;
  document.body.style.fontSize = perc + "px";
}

function pageLoader() {
  document.querySelector("html").classList.add("loadjs");
  const lf = document.querySelector(".loader-first");
  if (!lf) return;
  lf.style.opacity = "0";
  setTimeout(() => {
    document.querySelector("html").classList.remove("loadjs");
    try {
      lf.parentNode && lf.parentNode.removeChild(lf);
    } catch (e) {}
  }, 900);
}

function LoadAndResizer() {
  window.addEventListener("DOMContentLoaded", function () {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        pageLoader();
        if (window.innerWidth > 1199) {
          fontResizer();
        }
      });
    });
  });
  window.addEventListener("resize", (event) => {
    sw = window.innerWidth;
    sh = window.innerHeight;
    if (sw > 1025) {
      if (sw < 1400 && sw > 1300 && sh > 900) {
      } else {
        fontResizer();
      }
    }
  });
}

export default LoadAndResizer;
